function _isFunction(x) {
  var type = Object.prototype.toString.call(x);
  return type === '[object Function]' || type === '[object AsyncFunction]' || type === '[object GeneratorFunction]' || type === '[object AsyncGeneratorFunction]';
}

module.exports = _isFunction;


//////////////////
// WEBPACK FOOTER
// ./~/ramda/src/internal/_isFunction.js
// module id = 252
// module chunks = 0